// AccessibilityWidget port (תפריט נגישות): toggles a11y-* classes on <html>,
// persisted in localStorage "mizu-a11y". Focus enters the panel on open; Esc closes.
(() => {
  const root = document.querySelector('[data-mizu-a11y]');
  if (!root) return;
  const KEY = 'mizu-a11y';
  const FONT_STEPS = ['', 'a11y-font-lg', 'a11y-font-xl'];
  const TOGGLES = ['a11y-contrast', 'a11y-grayscale', 'a11y-links', 'a11y-motion', 'a11y-font'];
  const ACTIVE = ['border-ink', 'bg-ink', 'text-paper', 'hover:border-ink'];
  const toggle = root.querySelector('[data-mizu-a11y-toggle]');
  const panel = root.querySelector('[data-mizu-a11y-panel]');
  let state = { font: 0, on: [] };

  function apply() {
    const el = document.documentElement;
    FONT_STEPS.forEach((c) => c && el.classList.remove(c));
    if (FONT_STEPS[state.font]) el.classList.add(FONT_STEPS[state.font]);
    TOGGLES.forEach((c) => el.classList.toggle(c, state.on.includes(c)));
    const fontBtn = panel.querySelector('[data-a11y-font]');
    fontBtn.setAttribute('aria-pressed', String(state.font > 0));
    ACTIVE.forEach((c) => fontBtn.classList.toggle(c, state.font > 0));
    panel.querySelector('[data-a11y-font-label]').textContent = state.font > 0 ? `A+${state.font}` : 'A';
    panel.querySelectorAll('[data-a11y-toggle]').forEach((b) => {
      const on = state.on.includes(b.dataset.a11yToggle);
      b.setAttribute('aria-pressed', String(on));
      ACTIVE.forEach((c) => b.classList.toggle(c, on));
    });
  }
  function update(next) {
    state = next;
    apply();
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* storage blocked */ }
  }
  const open = () => { panel.hidden = false; toggle.setAttribute('aria-expanded', 'true'); panel.querySelector('button')?.focus(); };
  const close = () => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); };

  toggle.addEventListener('click', () => (panel.hidden ? open() : close()));
  root.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) close(); });
  panel.querySelector('[data-a11y-font]').addEventListener('click', () => update({ ...state, font: (state.font + 1) % FONT_STEPS.length }));
  panel.querySelectorAll('[data-a11y-toggle]').forEach((b) => b.addEventListener('click', () => {
    const cls = b.dataset.a11yToggle;
    update({ ...state, on: state.on.includes(cls) ? state.on.filter((c) => c !== cls) : [...state.on, cls] });
  }));
  panel.querySelector('[data-a11y-reset]').addEventListener('click', () => update({ font: 0, on: [] }));

  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || '');
    if (saved && typeof saved.font === 'number') state = saved;
  } catch { /* nothing saved */ }
  apply();
})();
